// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n * Created by moran on 8/10/17.\n */\n.btn.btn-modal-header-back {\n  background: none;\n  height: 56px;\n  width: 56px;\n  color: #5c5c5c;\n  font-size: 19px;\n  line-height: 56px;\n  padding: 0;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
